import Dashboard from "layouts/dashboard";
import SuperAdmin from "layouts/admin";
import AllProperties from "layouts/properties/all-properties";
// PropertiesFixed removed - debug component
import AddProperty from "layouts/properties/add-property";
import PropertyDetail from "layouts/properties/property-detail";
import Units from "layouts/properties/units";
import Documents from "layouts/properties/documents";
import TenantDirectory from "layouts/tenants/directory";
import Applications from "layouts/tenants/applications";
import ApplicationDetail from "layouts/tenants/applications/ApplicationDetail";
import Leases from "layouts/tenants/leases";
import QuickLease from "layouts/leasing/quick-lease";
import TenantPortal from "layouts/tenant-portal";
import MondayReportPage from "layouts/reports/monday-report";
import Rent from "layouts/financials/rent";
import Expenses from "layouts/financials/expenses";
import OwnerDistributions from "layouts/financials/owners";
import Requests from "layouts/maintenance/requests";
import Vendors from "layouts/maintenance/vendors";
import Inspections from "layouts/compliance/inspections";
import Violations from "layouts/compliance/violations";
import MarketingCampaigns from "layouts/marketing/campaigns";
import MarketingAutomation from "layouts/marketing/automation";
import TransactionDashboard from "layouts/transactions/dashboard";
import CommissionDashboard from "layouts/commissions/dashboard";
import CRMDashboard from "layouts/crm/dashboard";
import VendorDashboard from "layouts/vendors/dashboard";
import Chat from "layouts/chat";
import Settings from "layouts/settings";
import UserProfile from "layouts/profile/UserProfile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import EnhancedSignUp from "layouts/authentication/sign-up/EnhancedSignUp";
import AcceptInvite from "layouts/authentication/accept-invite";
import TwoFactorSetup from "layouts/authentication/two-factor-setup";
import TwoFactorVerify from "layouts/authentication/two-factor-verify";
// AuthTest removed - debug component
import { Navigate } from "react-router-dom";

import ArgonBox from "components/ArgonBox";
import PrivateRoute from "components/PrivateRoute";

const routes = [
  {
    type: "route",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <PrivateRoute><Dashboard /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Properties",
    key: "properties",
    icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-building" />,
    collapse: [
      {
        name: "All Properties",
        key: "all-properties", 
        route: "/properties/all",
        component: <PrivateRoute><AllProperties /></PrivateRoute>,
      },
      {
        name: "Add Property",
        key: "add-property",
        route: "/properties/add",
        component: <PrivateRoute><AddProperty /></PrivateRoute>,
      },
      {
        name: "Units & Floorplans",
        key: "units",
        route: "/properties/units",
        component: <PrivateRoute><Units /></PrivateRoute>,
      },
      {
        name: "Documents",
        key: "property-docs",
        route: "/properties/documents",
        component: <PrivateRoute><Documents /></PrivateRoute>,
      },
    ],
  },
  {
    type: "hidden",
    name: "Property Detail",
    key: "property-detail",
    route: "/properties/:id",
    component: <PrivateRoute><PropertyDetail /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Tenants",
    key: "tenants",
    icon: <ArgonBox component="i" color="success" fontSize="14px" className="ni ni-single-02" />,
    collapse: [
      {
        name: "Tenant Directory",
        key: "tenant-directory",
        route: "/tenants/directory",
        component: <PrivateRoute><TenantDirectory /></PrivateRoute>,
      },
      {
        name: "Applications",
        key: "applications",
        route: "/tenants/applications",
        component: <PrivateRoute><Applications /></PrivateRoute>,
      },
      {
        name: "Lease Agreements",
        key: "lease-agreements",
        route: "/tenants/leases",
        component: <PrivateRoute><Leases /></PrivateRoute>,
      },
    ],
  },
  {
    type: "hidden",
    name: "Application Detail",
    key: "application-detail",
    route: "/tenants/applications/:id",
    component: <PrivateRoute><ApplicationDetail /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Financials",
    key: "financials",
    icon: <ArgonBox component="i" color="warning" fontSize="14px" className="ni ni-credit-card" />,
    collapse: [
      {
        name: "Rent Collection",
        key: "rent",
        route: "/financials/rent",
        component: <PrivateRoute><Rent /></PrivateRoute>,
      },
      {
        name: "Expenses",
        key: "expenses",
        route: "/financials/expenses",
        component: <PrivateRoute><Expenses /></PrivateRoute>,
      },
      {
        name: "Owner Distributions",
        key: "owner-distributions",
        route: "/financials/owners",
        component: <PrivateRoute><OwnerDistributions /></PrivateRoute>,
      },
      {
        name: "Transactions",
        key: "transactions",
        route: "/financials/transactions",
        component: <PrivateRoute><TransactionDashboard /></PrivateRoute>,
      },
      {
        name: "Commissions",
        key: "commissions",
        route: "/financials/commissions",
        component: <PrivateRoute><CommissionDashboard /></PrivateRoute>,
      },
    ],
  },
  {
    type: "collapse",
    name: "Maintenance",
    key: "maintenance",
    icon: <ArgonBox component="i" color="error" fontSize="14px" className="ni ni-settings-gear-65" />,
    collapse: [
      {
        name: "Requests",
        key: "requests",
        route: "/maintenance/requests",
        component: <PrivateRoute><Requests /></PrivateRoute>,
      },
    ],
  },
  {
    type: "collapse",
    name: "Compliance",
    key: "compliance",
    icon: <ArgonBox component="i" color="secondary" fontSize="14px" className="ni ni-lock-circle-open" />,
    collapse: [
      {
        name: "Inspections",
        key: "inspections",
        route: "/compliance/inspections",
        component: <PrivateRoute><Inspections /></PrivateRoute>,
      },
      {
        name: "Violations",
        key: "violations",
        route: "/compliance/violations",
        component: <PrivateRoute><Violations /></PrivateRoute>,
      },
    ],
  },
  {
    type: "collapse",
    name: "Marketing",
    key: "marketing",
    icon: <ArgonBox component="i" color="dark" fontSize="14px" className="ni ni-email-83" />,
    collapse: [
      {
        name: "Campaigns",
        key: "campaigns",
        route: "/marketing/campaigns",
        component: <PrivateRoute><MarketingCampaigns /></PrivateRoute>,
      },
      {
        name: "Automation",
        key: "automation",
        route: "/marketing/automation",
        component: <PrivateRoute><MarketingAutomation /></PrivateRoute>,
      },
    ],
  },
  {
    type: "collapse",
    name: "CRM",
    key: "crm",
    icon: <ArgonBox component="i" color="success" fontSize="14px" className="ni ni-single-02" />,
    collapse: [
      {
        name: "CRM",
        key: "crm-dashboard",
        route: "/crm/dashboard",
        component: <PrivateRoute><CRMDashboard /></PrivateRoute>,
      },
      {
        name: "Vendors",
        key: "crm-vendors",
        route: "/crm/vendors",
        component: <PrivateRoute><VendorDashboard /></PrivateRoute>,
      },
    ],
  },
  {
    type: "route",
    name: "Quick Lease",
    key: "quick-lease",
    route: "/quick-lease",
    icon: <ArgonBox component="i" color="success" fontSize="14px" className="ni ni-single-copy-04" />,
    component: <PrivateRoute><QuickLease /></PrivateRoute>,
  },
  {
    type: "hidden",
    name: "Chat",
    key: "chat",
    route: "/chat",
    icon: <ArgonBox component="i" color="dark" fontSize="14px" className="ni ni-chat-round" />,
    component: <PrivateRoute><Chat /></PrivateRoute>,
  },
  {
    type: "route",
    name: "Monday Report",
    key: "monday-report",
    route: "/monday-report",
    icon: <ArgonBox component="i" color="info" fontSize="14px" className="ni ni-calendar-grid-58" />,
    component: <PrivateRoute><MondayReportPage /></PrivateRoute>,
  },
  {
    type: "hidden",
    name: "Super Admin",
    key: "super-admin",
    route: "/admin",
    component: <PrivateRoute><SuperAdmin /></PrivateRoute>,
  },
  // Root redirects to sign-in (landing page is on prmcore.com)
  {
    type: "hidden",
    name: "Landing",
    key: "landing",
    route: "/",
    component: <Navigate to="/authentication/sign-in" replace />,
  },
  {
    type: "hidden",
    name: "Settings",
    key: "settings",
    route: "/settings",
    component: <PrivateRoute><Settings /></PrivateRoute>,
  },
  {
    type: "hidden",
    name: "Tenant Portal",
    key: "tenant-portal",
    route: "/tenant/portal/:token",
    component: <TenantPortal />,
  },
  {
    type: "hidden",
    name: "Profile",
    key: "profile",
    route: "/profile",
    component: <PrivateRoute><UserProfile /></PrivateRoute>,
  },
  {
    type: "hidden",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "hidden", 
    name: "Sign Up",
    key: "sign-up",
    route: "/authentication/sign-up",
    component: <EnhancedSignUp />,
  },
  {
    type: "hidden",
    name: "Accept Invite",
    key: "accept-invite",
    route: "/authentication/accept-invite/:token",
    component: <AcceptInvite />,
  },
  {
    type: "hidden",
    name: "Two Factor Setup",
    key: "two-factor-setup",
    route: "/settings/two-factor-setup",
    component: <PrivateRoute><TwoFactorSetup /></PrivateRoute>,
  },
  {
    type: "hidden",
    name: "Two Factor Verify",
    key: "two-factor-verify",
    route: "/authentication/two-factor-verify",
    component: <TwoFactorVerify />,
  },
];

export default routes;
